import { PocTooltip } from 'commons/components/components-wrapper';
import styled from 'styled-components';

export const TwoLevelTooltip = styled(PocTooltip)`
    /* OWC-OVERRIDE: let the tooltip title span the full width so the two-level layout (title
       above body) aligns left. owc-tooltip sizes its title to content in v7.6.0 and exposes
       no layout prop. */
    .owc-tooltip__title {
        width: 100%;
    }

    span {
        display: flex;
        align-items: center;
        font-size: var(--one-typography-desktop-caption-font-size);
        font-weight: var(--one-typography-desktop-caption-font-weight);

        owc-icon {
            font-size: 1.2rem;
        }
    }
`;
